jQuery(document).ready(function ($) {

    var verticalVideoArray = [];
    var currentVerticalVideoIndex = -1;

    $('[data-video-format="vertical"]').each(function(){
        if ($(this).attr('data-video-id') != 'undefined' && $(this).attr('data-video-id') != '') {
            verticalVideoArray.push($(this).attr('data-video-id'));
        }
    });

    function getVideoURL(videoID){
        if (!videoID) {
            console.error('Video ID is required');
            return '';
        }
        var baseURL = 'https://www.youtube.com/embed/' + videoID + '?autoplay=0&mute=0&rel=0&modestbranding=1&playsinline=1';
        
        return baseURL;
    }

    function populateModalVideo(videoID, target){
        var videoURL = getVideoURL(videoID);
        target.find('iframe').attr('src', videoURL);
    }

    function openVideoModal(videoID, format){
        var modalTarget = $('.horizontalVideoModal')

        if (format == 'vertical'){
            modalTarget = $('.verticalVideoModal');

            for (var i = 0; i < verticalVideoArray.length; i++) {
                if (verticalVideoArray[i] == videoID) {
                    currentVerticalVideoIndex = i;
                }
            }
        }

        populateModalVideo(videoID, modalTarget);
        modalTarget.fadeIn();
    }
    
    $('[data-video-id]').on('click', function(){
        var videoID = $(this).attr('data-video-id');
        var format = 'horizontal';
        if ($(this).attr('data-video-format')) {
            format = $(this).attr('data-video-format');
        }
        openVideoModal(videoID, format);
    });

    $('.verticalVideoModal__close').on('click', function(){
        $('.verticalVideoModal').fadeOut();
        $('.verticalVideoModal iframe').attr('src', '');
    });

    $('.horizontalVideoModal__background').on('click', function(){
        $('.horizontalVideoModal').fadeOut();
        $('.horizontalVideoModal iframe').attr('src', '');
    });

    if (verticalVideoArray.length > 0){
        $('.verticalVideoModal__controls').show();
    }
    else{
        $('.verticalVideoModal__controls').hide();
    }

    $('.verticalVideoModal__controlButton').on('click', function(){
        var oldIndex = currentVerticalVideoIndex;
        if ($(this).hasClass('verticalVideoModal__controlButton--previous')){
            oldIndex--;
        }
        else if ($(this).hasClass('verticalVideoModal__controlButton--next')){
            oldIndex++;
        }
        if (oldIndex < 0){
            oldIndex = verticalVideoArray.length - 1;
        }
        else if (oldIndex >= verticalVideoArray.length){
            oldIndex = 0;
        }
        currentVerticalVideoIndex = oldIndex;

        console.log(verticalVideoArray.length);

        console.log(currentVerticalVideoIndex);
        populateModalVideo(verticalVideoArray[currentVerticalVideoIndex], $('.verticalVideoModal'));
    });

    var thumbnailsSwiper = new Swiper('.slideshowModal__thumbnailsWrapper', {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: false
    });

    var sliderSwiper = new Swiper('.slideshowModal__sliderWrapper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: '.slideshowModal__nextButton',
            prevEl: '.slideshowModal__prevButton',
        },
        thumbs: {
            swiper: '.slideshowModal__thumbnailsWrapper'
        }
    });

    $('.slideshowModal').hide().removeClass('slideshowModal--unloaded');
    

    $('.pdpMain__galleryButton').on('click', function(){
        var slideIndex = $(this).closest('.pdpMain__imageBlock').attr('data-image');
        $('.slideshowModal').fadeIn();
        sliderSwiper.update();
        thumbnailsSwiper.update();
        sliderSwiper.slideTo(slideIndex);
        thumbnailsSwiper.slideTo(slideIndex);
    });

    $('.slideshowModal__close').on('click', function(){
        $('.slideshowModal').fadeOut();
    });

    // Tooltip system
    var $tooltipModal = $('.tooltipModal');
    var $tooltipContent = $('.tooltipModal__content');
    var tooltipWidth = 327;
    var currentTooltipElement = null;

    function updateTooltipPosition(e) {
        if (!$tooltipModal.is(':visible')) {
            return;
        }

        // For fixed positioning, use clientX/clientY (viewport coordinates)
        // or subtract scroll position from pageX/pageY
        var scrollLeft = $(window).scrollLeft();
        var scrollTop = $(window).scrollTop();
        var mouseX = e.pageX - scrollLeft;
        var mouseY = e.pageY - scrollTop;
        var windowWidth = $(window).width();
        var offsetY = 10; // Offset below cursor

        // Calculate if tooltip would go off right edge
        var spaceOnRight = windowWidth - mouseX;
        var isNearEdge = spaceOnRight < tooltipWidth;

        // Position tooltip (fixed positioning uses viewport coordinates)
        $tooltipModal.css({
            top: mouseY + offsetY + 'px',
            left: mouseX + 'px'
        });

        // Add/remove edge class
        if (isNearEdge) {
            $tooltipModal.addClass('tooltipModal--edge');
        } else {
            $tooltipModal.removeClass('tooltipModal--edge');
        }
    }

    function showTooltip(element, content) {
        $tooltipContent.html(content);
        $tooltipModal.show();
        currentTooltipElement = element;
    }

    function hideTooltip() {
        $tooltipModal.hide();
        $tooltipContent.html('');
        currentTooltipElement = null;
        $tooltipModal.removeClass('tooltipModal--edge');
    }

    // Handle hover on elements with data-tooltip
    $(document).on('mouseenter', '[data-tooltip]', function(e) {
        var tooltipContent = $(this).attr('data-tooltip');
        if (tooltipContent) {
            showTooltip($(this), tooltipContent);
            updateTooltipPosition(e);
        }
    });

    // Update position as mouse moves over trigger element
    $(document).on('mousemove', '[data-tooltip]', function(e) {
        if (currentTooltipElement && currentTooltipElement.is($(this))) {
            updateTooltipPosition(e);
        }
    });

    // Hide tooltip when mouse leaves trigger element
    $(document).on('mouseleave', '[data-tooltip]', function() {
        if (currentTooltipElement && currentTooltipElement.is($(this))) {
            hideTooltip();
        }
    });

    // Also hide tooltip if mouse moves over the tooltip itself (optional - remove if you want tooltip to stay visible when hovering over it)
    $tooltipModal.on('mouseenter', function() {
        // Keep tooltip visible when hovering over it
    });

    $tooltipModal.on('mouseleave', function() {
        hideTooltip();
    });
    
});